import React, { useState, useEffect } from 'react';
import Linkpages from "./Linkpages";
import { useTranslation } from "react-i18next";
import '../css/vagadent.css';
import '../css/blog.css';
import '../css/media.css';

import blogImg1 from '../images/blog1.jpg';
import blogImg2 from '../images/blog2.jpg';
import blogImg3 from '../images/blog3.jpg';
import blogImg4 from '../images/blog4.jpg';

function Blog(props) {
    const { t, i18n } = useTranslation("common");
    const [menuOpen, setMenuOpen] = useState(false);
    const [currentIndex, setCurrentIndex] = useState(0);
    const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);

    useEffect(() => {
        const handleResize = () => {
            setIsMobile(window.innerWidth <= 768);
        };
        window.addEventListener('resize', handleResize);
        return () => window.removeEventListener('resize', handleResize);
    }, []);

    const articles = [
        { id: 1, title: 'blog.implant', img: blogImg1 },
        { id: 2, title: 'blog.spitakecum', img: blogImg2 },
        { id: 3, title: 'blog.shapik', img: blogImg3 },
        { id: 4, title: 'blog.heracum', img: blogImg4 }
    ];

    // Մաքսիմալ քայլերը համակարգչի համար
    const maxIndex = articles.length - 3;

    // ⚡ ՄԱՔՈՒՐ SCROLL ՖՈՒՆԿՑԻԱՆԵՐ ՀԵՌԱԽՈՍԻ ՈՒ ՀԱՄԱԿԱՐԳՉԻ ՀԱՄԱՐ
    const nextSlide = () => {
        if (isMobile) {
            const container = document.querySelector('.blog-slider-container');
            if (container) {
                container.scrollBy({ left: container.offsetWidth - 50, behavior: 'smooth' });
            }
        } else {
            if (currentIndex < maxIndex) {
                setCurrentIndex(currentIndex + 1);
            }
        }
    };

    const prevSlide = () => {
        if (isMobile) {
            const container = document.querySelector('.blog-slider-container');
            if (container) {
                container.scrollBy({ left: -(container.offsetWidth - 50), behavior: 'smooth' });
            }
        } else {
            if (currentIndex > 0) {
                setCurrentIndex(currentIndex - 1);
            }
        }
    };

    // Համակարգչի սահելու հաշվարկը
    const desktopTranslate = currentIndex * (100 / 3 + 1.5);

    return (
        <div className="blog-page-wrapper">
            <div className="blog-bg-overlay"></div>

            {/* HEADER SECTION */}
            <div className="header-container">
                <div className="logo-group">
                    <div className="logo"></div>
                    <div className="brand-text">
                        <div className="vagadent">{t('welcome.title')}</div>
                        <div className="dental">{t('welcome.title1')}</div>
                    </div>
                </div>

                <div className={`nav-menu ${menuOpen ? 'open' : ''}`}>
                    <Linkpages />
                </div>

                <div className="header-right">
                    <div className="leng">
                        <button onClick={() => i18n.changeLanguage('hay')}>ՀԱՅ</button>
                        <button onClick={() => i18n.changeLanguage('ru')}>РУ</button>
                        <button onClick={() => i18n.changeLanguage('en')}>ENG</button>
                    </div>
                    <div className={`menu-dots ${menuOpen ? 'active' : ''}`} onClick={() => setMenuOpen(!menuOpen)}>
                        <span></span>
                        <span></span>
                        <span></span>
                    </div>
                </div>
            </div>

            {/* MAIN BLOG SECTION */}
            <section className="blog-section">
                <div className="blog-container">

                    <div className="blog-title-block">
                        <h2 className="blog-title">{t('menu.blog')}</h2>
                        <div className="gallery-line"></div>
                    </div>

                    <div className="blog-slider-outer">
                        {/* Ձախ կոճակ */}
                        <button
                            className="slider-btn prev"
                            onClick={prevSlide}
                        >
                            ‹
                        </button>

                        <div className="blog-slider-container">
                            <div
                                className="blog-grid"
                                style={{
                                    transform: isMobile ? 'none' : `translateX(-${desktopTranslate}%)`
                                }}
                            >
                                {articles.map((art) => (
                                    <div
                                        className="blog-card"
                                        key={art.id}
                                    >
                                        <div
                                            className="blog-img-box"
                                            style={{ backgroundImage: `url(${art.img})` }}
                                        ></div>
                                        <div className="blog-title-box-inner">
                                            <h4 className="blog-card-title">{t(art.title)}</h4>
                                        </div>
                                    </div>
                                ))}
                            </div>
                        </div>

                        {/* Աջ կոճակ */}
                        <button
                            className="slider-btn next"
                            onClick={nextSlide}
                        >
                            ›
                        </button>
                    </div>

                </div>
            </section>
        </div>
    );
}

export default Blog;